import React from 'react';
import { Bold, Heading, Text } from '../typography';
import PremierBookButton, { BookButton, CanBook } from './PremierBookButton';
import {
  Container,
  Wrapper,
  Content,
  MockupContainer,
  MockupWrapper,
  MockupContent,
  MockupImage,
  PromoteBadge,
  ButtonContainer,
  LeftFeatures,
  RightFeatures,
  FeatureItem,
  PromoteFeatures,
} from './PromoteSuperfeature.style';

type PromoteSuperfeatureFeature = { title: string; text: string };

interface PromoteSuperfeatureProps {
  title: string;
  mockup: {
    src: string;
    alt: string;
    aspectRatio: string;
  };
  badge: {
    title: string;
    text: string;
    subtext?: string;
    textMw?: number;
    mobTextMw?: number;
    titleMt?: number;
    titleMw?: number;
    size?: number;
    mobSize?: number;
  };
  button: BookButton;
  features: [PromoteSuperfeatureFeature[] | undefined, PromoteSuperfeatureFeature[] | undefined];
  canBook: CanBook;
  pb?: number;
}

const PromoteSuperfeature: React.FC<PromoteSuperfeatureProps> = ({
  title,
  mockup,
  badge,
  button,
  features,
  canBook,
  pb,
}) => {
  return (
    <Container data-testid="promote-superfeature" pb={pb}>
      <Wrapper>
        <Heading align="center" fontSize={44} data-testid="promote-superfeature-title">
          {title}
        </Heading>
        <Content>
          <MockupContainer shiftLeft={!(features?.[0] && features?.[0]?.length > 0)}>
            <PromoteBadge
              data-testid="promote-badge"
              hasSubtext={!!badge.subtext}
              textMw={badge?.textMw}
              titleMw={badge?.titleMw}
              mobTextMw={badge?.mobTextMw}
              titleMt={badge?.titleMt}
              size={badge?.size}
              mobSize={badge?.mobSize}
            >
              <span data-testid="promote-badge-title" className="badge-title">
                {badge.title}
              </span>
              <span data-testid="promote-badge-text" className="badge-text">
                {badge.text}
              </span>
              {badge.subtext && (
                <span data-testid="promote-badge-subtext" className="badge-subtext">
                  {badge.subtext}
                </span>
              )}
            </PromoteBadge>
            <MockupWrapper aspectRatio={mockup.aspectRatio}>
              <MockupContent>
                <MockupImage data-testid="mockup-image" src={mockup.src} alt={mockup.alt} />
              </MockupContent>
            </MockupWrapper>
            <PromoteFeatures>
              {features?.[0] && features?.[0]?.length > 0 && (
                <LeftFeatures data-testid="promote-features-left">
                  {features?.[0]?.map((f) => (
                    <FeatureItem key={f.title} data-testid="promote-feature-left">
                      <Bold fontSize={18} lineHeight={28} mb={6}>
                        {f.title}
                      </Bold>
                      <Text lineHeight={24}>{f.text}</Text>
                    </FeatureItem>
                  ))}
                </LeftFeatures>
              )}
              {features?.[1] && features?.[1]?.length > 0 && (
                <RightFeatures data-testid="promote-features-right">
                  {features?.[1]?.map((f) => (
                    <FeatureItem key={f.title} data-testid="promote-feature-right">
                      <Bold fontSize={18} lineHeight={28} mb={6}>
                        {f.title}
                      </Bold>
                      <Text lineHeight={24}>{f.text}</Text>
                    </FeatureItem>
                  ))}
                </RightFeatures>
              )}
            </PromoteFeatures>
          </MockupContainer>
        </Content>
        <MockupContainer>
          <ButtonContainer>
            <PremierBookButton button={button} canBook={canBook} testID="promote-button" />
          </ButtonContainer>
        </MockupContainer>
      </Wrapper>
    </Container>
  );
};

export default PromoteSuperfeature;
